import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import {
  getUIPathCurrentConnector

} from '../../store/selectors/rpa-uipath-conn.selector';

import {
  getUipathErrorSelector
} from '../../store/selectors/rpa-uipath-dashboard.selector';

import {
  getUIPathJobsList,
  getUIPathQueueitemsList,
  UIPathRetryJob,
  UIPathResetJobRetry,
  UIPathRetryQueueitem,
  UIPathResetQueueitemRetry,
  resetRetries,
  UIPathResetErrorHandler
} from '../../store/actions/rpa-uipath-dashboard.actions';

import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'i18n/i18n.service';

import { BzgTabChangeEvent, BzgToastService, BzgToastType } from 'bz-genome-angular';
import { IAppState } from 'app/IAppState';
import { IQueueItem } from '../../common/models/IQueueItem';
import { IRpaConnectionUiPath } from 'app/rpa-bots/core/IRpaBots';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
  selector: 'biz-uipath-retries-wrapper',
  templateUrl: './uipath-retries-wrapper.component.html',
  styleUrls: ['./uipath-retries-wrapper.component.scss']
})
export class UipathRetriesWrapperComponent implements OnInit {

  @Input()
  public uiPathOriginalConnection: IRpaConnectionUiPath;

  uiPathConnection$: Observable<IRpaConnectionUiPath>;
  dataQueueitems: Observable<IQueueItem[]>;
  uiPathConnectionSubscriber: any;
  isError$: Observable<boolean>;
  isErrorSubscriber: any;

  private currentUiPathConnection: IRpaConnectionUiPath;

  constructor(private _translateService: TranslateService, private _store: Store<IAppState>, private _i18nService: I18nService, private _toastService: BzgToastService, private _showToastService: ShowToastService) {

    this.uiPathConnection$ = this._store.pipe(
      select(getUIPathCurrentConnector)
    );
    this.uiPathConnectionSubscriber = this.uiPathConnection$.subscribe(uiPathConnection => this.currentUiPathConnection = uiPathConnection);
    this.isError$ = this._store.pipe(
      select(getUipathErrorSelector)
    );

    this.isErrorSubscriber = this.isError$.subscribe((error) => {
      if (error) {
        this._showToastService.showToast(this._i18nService.instant('GLOBAL.GENERIC_ERROR_MSG'), 'error');
        this._store.dispatch(new UIPathResetErrorHandler())
      }
    });


  }

  ngOnInit() {
    this.getJobsData();
  }

  ngOnDestroy() {
    this._store.dispatch(new resetRetries());

    if(this.uiPathConnectionSubscriber) {
      this.uiPathConnectionSubscriber.unsubscribe();
    }

    if(this.isErrorSubscriber) {
      this.isErrorSubscriber.unsubscribe();
    }
  }

  getJobsData() {
    let connectionData = Object.assign({}, this.uiPathOriginalConnection);
    let payload = {
        connection: connectionData,
        filter: '$expand=Robot&$filter=State eq \'Faulted\'&$orderby=CreationTime desc'
      }
    this._store.dispatch(new getUIPathJobsList(payload));
  }

  retryJob(event: any) {
    let connectionData = Object.assign({}, this.uiPathOriginalConnection);
    let payload = {
      connection: connectionData,
      jobKey: event.jobKey,
      inputArguments: event.inputArguments
    }
    this._store.dispatch(new UIPathRetryJob(payload));
  }

  retryQueueitem(event: any) {
    let connectionData = Object.assign({}, this.uiPathOriginalConnection);
    connectionData.processes = null;
    let payload = {
      connection: connectionData,
      queueid: event.Id.toString(),
      priority: event.Priority,
      specificcontent: event.SpecificContent === null ? '' : (JSON.stringify(event.SpecificContent)).toString(),
      deferdate: event.DeferDate === null ? '' : event.DeferDate,
      duedate: event.DueDate === null ? '' : event.DueDate,
      reference: event.Reference === null ? '' : event.Reference
    }
    this._store.dispatch(new UIPathRetryQueueitem(payload));
  }

  resetJobRetry() {
    this._store.dispatch(new UIPathResetJobRetry());
  }

  resetQueueitemRetry() {
    this._store.dispatch(new UIPathResetQueueitemRetry());
  }

  onTabEvent(event: BzgTabChangeEvent) {
    if (event.index === 1 && !this.dataQueueitems) {
      let connectionData = Object.assign({}, this.uiPathOriginalConnection);
      let payload = {
        connection: connectionData,
        filter: '$expand=QueueDefinition&$filter=Status eq \'Failed\'&$orderby=CreationTime desc'
      }
      this._store.dispatch(new getUIPathQueueitemsList(payload));
    }
  }

}
